const addMonth = function(datetime, month) {
    datetime.setMonth(datetime.getMonth() + month)
    return datetime
}
const addDay = function(datetime, day) {
    datetime.setDate(datetime.getDate() + day)
    return datetime
}
const getWeekDay = function(date) {
    const weekDay = date.getDay()
    const weekDayMap = ['日', '一', '二', '三', '四', '五', '六']
    return weekDayMap[weekDay]
}
const parseDate = function(dateStr) {
    // 处理日期字符串，格式为2025-05-15T00:00:00.000Z
    // 1. 校验输入是否为字符串
    if (typeof dateStr !== 'string') {
        console.error('Invalid input: Expected a string')
        return null;
    }

    // 2. 解析日期
    const date = new Date(dateStr)
    if (dateStr.indexOf('T') > -1) {
        // 2. 提取原始小时数（UTC 时间）
        const timeMatch = dateStr.match(/T(\d{2})/);
        if (!timeMatch) {
            console.error('Invalid date format: Missing time part');
            return null;
        }
        const originalUTCHour = parseInt(timeMatch[1], 10);
        // 4. 获取本地时区的小时数
        const localHour = date.getHours();

        // 5. 校验小时差异（假设本地时区为 UTC+8）
        if (originalUTCHour !== localHour) {
            // 减去 8 小时调整回 UTC 时间
            date.setTime(date.getTime() - 8 * 60 * 60 * 1000);
        }
    }
    // 3. 校验解析结果是否有效
    if (isNaN(date.getTime())) {
        console.error('Invalid date string:', dateStr)
        return null
    }

    // 4. 返回处理后的结果（根据需求选择返回值）
    // 示例 1: 返回 Date 对象
    return date

    // 示例 2: 返回格式化字符串（YYYY-MM-DD HH:mm:ss）
    // return date.toISOString().replace(/T/, ' ').replace(/\..+/, '');

    // 示例 3: 返回本地时间字符串
    // return date.toLocaleString();
}

const datetimeFormat = function(date, str) {
    if (typeof date === 'string') {
        date = parseDate(date)
    }
    if (!date || !(date instanceof Date)) return ''

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hour = String(date.getHours()).padStart(2, '0')
    const minute = String(date.getMinutes()).padStart(2, '0')
    const second = String(date.getSeconds()).padStart(2, '0')
    const monthShortEn = getMonthShortEn(date)

    const ret = str.replace('yyyy', year)
                 .replace('yy', year)
                 .replace('MM', month)
                 .replace('dd', day)
                 .replace('hh', hour)
                 .replace('mm', minute)
                 .replace('ss', second)
                 .replace('MeMe', second)
                 .replace('MEME', monthShortEn.toUpperCase())
    return ret
}
const getMonthShortEn = function(date) {
    const lang = navigator.language // 获取当前语言环境
    const month = date.getMonth()

    if (lang === 'zh-CN') {
      // 中文环境下，使用固定的月份缩写
      const monthShortCn = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二']
      return `M${monthShortCn[month]}月`
    } else {
      // 英文环境下，从语言包中获取对应的月份缩写
      const monthShortEn = {
        'en-US': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        'en-GB': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        'en-CA': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        'en-AU': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        // ...可以根据实际需要添加更多语言的月份缩写
      }
      return monthShortEn[lang][month]
    }
}
const isToday = function(date) {
    if (!date) return false
    // 如果date是字符串，需要转换为Date对象
    if (typeof date === 'string') {
        date = new Date(date)
    }
    const today = new Date()
    return date.toDateString() === today.toDateString()
}
const isYesterday = function(date) {
    if (!date) return false
    // 如果date是字符串，需要转换为Date对象
    if (typeof date === 'string') {
        date = new Date(date)
    }
    const yesterday = new Date()
    yesterday.setDate(yesterday.getDate() - 1)
    return date.toDateString() === yesterday.toDateString()
}
export default {
    addMonth,
    addDay,
    datetimeFormat,
    isToday,
    isYesterday,
    getWeekDay
}
